export const BLACK = '#27272E';
export const GRAY_DARK = '#6F6F6F';
export const GRAY_LIGHT = '#797979';
export const PRIMARY = '#ED1C25';
export const SECONDARY = '#FFF8F8';
export const WHITE = '#FFFFFF';
export const HEADER_COLOR = '#1F1D1A';
export const BACKGROUND_CATEGORIES = '#231F20';
export const CART_BUTTON = '#ECFFF4';
export const CART_TEXT = '#379246';

export const SEARCH_BACKGROUND = '#F5F6FA';
export const SEARCH_BORDER = '#D5D5D5';
export const SEARCH_COLOR = '#6E727A';

export const GRAY = '#878787';
export const FADE_BLACK = '#363636';

export const ORDERTHAT_RED = '#ED1C25';
